export const defaultEquipment = [
    {
      _id: "random-_id-1",
      source: "system",
      name: "5kg Dumbbell",
      measurements: [{ name: "Weight", unit: "kg", value: 5 }],
    },
    {
      _id: "random-_id-2",
      source: "system",
      name: "10kg Dumbbell",
      measurements: [{ name: "Weight", unit: "kg", value: 10 }],
    },
    {
      _id: "random-_id-3",
      source: "system",
      name: "15kg Dumbbell",
      measurements: [{ name: "Weight", unit: "kg", value: 15 }],
    },
    {
      _id: "random-_id-4",
      source: "system",
      name: "TRX",
      measurements: [{ name: "Length", unit: "m", value: 3 }],
    },
    {
      _id: "random-_id-5",
      source: "system",
      name: "Hand Gripper (5kg)",
      measurements: [{ name: "Resistance", unit: "kg", value: 5 }],
    },
    {
      _id: "random-_id-6",
      source: "system",
      name: "Hand Gripper (10kg)",
      measurements: [{ name: "Resistance", unit: "kg", value: 10 }],
    },
    {
      _id: "random-_id-7",
      source: "system",
      name: "Hand Gripper (20kg)",
      measurements: [{ name: "Resistance", unit: "kg", value: 20 }],
    },
    {
      _id: "random-_id-8",
      source: "system",
      name: "Hand Gripper (30kg)",
      measurements: [{ name: "Resistance", unit: "kg", value: 30 }],
    },
    {
      _id: "random-_id-9",
      source: "system",
      name: "Jump Rope",
      measurements: [{ name: "Length", unit: "m", value: 3 }],
    },
    {
      _id: "random-_id-10",
      source: "system",
      name: "Pull-Up Bar",
      measurements: [{ name: "W_idth", unit: "m", value: 1.2 }],
    },
    {
      _id: "random-_id-11",
      source: "system",
      name: "Kettlebell (8kg)",
      measurements: [{ name: "Weight", unit: "kg", value: 8 }],
    },
    {
      _id: "random-_id-12",
      source: "system",
      name: "Kettlebell (12kg)",
      measurements: [{ name: "Weight", unit: "kg", value: 12 }],
    },
    {
      _id: "random-_id-13",
      source: "system",
      name: "Kettlebell (16kg)",
      measurements: [{ name: "Weight", unit: "kg", value: 16 }],
    },
    {
      _id: "random-_id-14",
      source: "system",
      name: "Resistance Bands (Light)",
      measurements: [{ name: "Resistance", unit: "kg", value: 5 }],
    },
    {
      _id: "random-_id-15",
      source: "system",
      name: "Resistance Bands (Medium)",
      measurements: [{ name: "Resistance", unit: "kg", value: 10 }],
    },
    {
      _id: "random-_id-16",
      source: "system",
      name: "Resistance Bands (Heavy)",
      measurements: [{ name: "Resistance", unit: "kg", value: 20 }],
    },
    {
      _id: "random-_id-17",
      source: "system",
      name: "Medicine Ball (3kg)",
      measurements: [{ name: "Weight", unit: "kg", value: 3 }],
    },
    {
      _id: "random-_id-18",
      source: "system",
      name: "Medicine Ball (5kg)",
      measurements: [{ name: "Weight", unit: "kg", value: 5 }],
    },
    {
      _id: "random-_id-19",
      source: "system",
      name: "Ab Wheel",
      measurements: [{ name: "Diameter", unit: "cm", value: 30 }],
    },
    {
      _id: "random-_id-20",
      source: "system",
      name: "Exercise Mat",
      measurements: [{ name: "Length", unit: "m", value: 1.8 }],
    },
    {
      _id: "random-_id-21",
      source: "system",
      name: "Barbell",
      measurements: [{ name: "Weight", unit: "kg", value: 20 }],
    },
    {
      _id: "random-_id-22",
      source: "system",
      name: "Barbell Plates (10kg)",
      measurements: [{ name: "Weight", unit: "kg", value: 10 }],
    },
    {
      _id: "random-_id-23",
      source: "system",
      name: "Barbell Plates (20kg)",
      measurements: [{ name: "Weight", unit: "kg", value: 20 }],
    },
    {
      _id: "random-_id-24",
      source: "system",
      name: "Dumbbell Rack",
      measurements: [{ name: "Capacity", unit: "kg", value: 50 }],
    },
    {
      _id: "random-_id-25",
      source: "system",
      name: "Squat Rack",
      measurements: [{ name: "Height", unit: "m", value: 2.5 }],
    },
    {_id: "random-_id-26", source: "system", name: "20kg Dumbbell", measurements: [{name: "Weight", unit: "kg", value: 20}]},
    {_id: "random-_id-27", source: "system", name: "25kg Dumbbell", measurements: [{name: "Weight", unit: "kg", value: 25}]},
    {_id: "random-_id-28", source: "system", name: "30kg Dumbbell", measurements: [{name: "Weight", unit: "kg", value: 30}]},
    {_id: "random-_id-29", source: "system", name: "40kg Dumbbell", measurements: [{name: "Weight", unit: "kg", value: 40}]},
    {_id: "random-_id-30", source: "system", name: "50kg Dumbbell", measurements: [{name: "Weight", unit: "kg", value: 50}]},
    {_id: "random-_id-31", source: "system", name: "60kg Dumbbell", measurements: [{name: "Weight", unit: "kg", value: 60}]},
    {_id: "random-_id-32", source: "system", name: "Barbell (15kg)", measurements: [{name: "Weight", unit: "kg", value: 15}]},
    {_id: "random-_id-33", source: "system", name: "Barbell (25kg)", measurements: [{name: "Weight", unit: "kg", value: 25}]},
    {_id: "random-_id-34", source: "system", name: "Barbell (35kg)", measurements: [{name: "Weight", unit: "kg", value: 35}]},
    {_id: "random-_id-35", source: "system", name: "Power Rack", measurements: [{name: "Height", unit: "m", value: 2.5}]},
    {_id: "random-_id-36", source: "system", name: "Push-Up Bars", measurements: [{name: "Height", unit: "cm", value: 15}]},
    {_id: "random-_id-37", source: "system", name: "Dip Bars", measurements: [{name: "Height", unit: "cm", value: 120}]},
    {_id: "random-_id-38", source: "system", name: "Weighted Vest (10kg)", measurements: [{name: "Weight", unit: "kg", value: 10}]},
    {_id: "random-_id-39", source: "system", name: "Weighted Vest (20kg)", measurements: [{name: "Weight", unit: "kg", value: 20}]},
    {_id: "random-_id-40", source: "system", name: "Sandbag (15kg)", measurements: [{name: "Weight", unit: "kg", value: 15}]}

  ];

  